import { AppShell } from '@/components/layout/AppShell';
import { Tabs } from '@/components/ui/Tabs';
import { SmsContent } from '../sms/page';
import { PhoneContent } from '../phone/page';
import { useTabState } from '@/hooks/useTabState';
import { rxkModuleIcon, rxkModuleTitle, rxkNavGroups } from '../nav';

type Tab = 'sms' | 'phone';

// One sidebar entry ("Communications") for two related tools that each
// used to be their own top-level page — SmsContent/PhoneContent are the
// exact same components, just with their own AppShell stripped out so
// there's only one shell (and one page-permission entry) for both.
export default function AdminCommunications() {
  const [tab, setTab] = useTabState<Tab>('phone', ['sms', 'phone']);

  return (
    <AppShell moduleTitle={rxkModuleTitle} moduleIcon={rxkModuleIcon} navGroups={rxkNavGroups}>
      <div className="space-y-4">
        <Tabs
          tabs={[
            { key: 'phone', label: 'Phone' },
            { key: 'sms', label: 'Send SMS' },
          ]}
          active={tab}
          onChange={(k) => setTab(k as Tab)}
        />
        {tab === 'phone' ? <PhoneContent /> : <SmsContent />}
      </div>
    </AppShell>
  );
}
